export default function (state = null, action) {
  switch (action.type) {
    case 'ENSURE_CLIENT_IDENTITY_SUCCESS':
      return action.response
    default:
      return state
  }
}
